export default __webpack_public_path__ + "static/media/Investment Advisory.7aac0383.svg";